import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "./pages/home";
import Register from "./pages/register";
import Login from "./pages/login";
import Admin from "./pages/admin";
import BuyPlans from "./pages/BuyPlans.jsx";
import ForgotPassword from "./pages/ForgotPassword.jsx";
import ResetPasswordPage from "./pages/ResetPasswordPage.jsx";
import DownloadPage from "./pages/downloadPage";
import Dashboard from "./pages/dashboard";
import Practice from "./pages/practice";
import ConfigureResume from "./pages/ConfigureResume.jsx";
import GenerateResumeWithAI from "./pages/GenerateResumeWithAI";
import ResumePreview from "./pages/ResumePreview";
import PaymentSuccess from "./pages/PaymentSuccess";
import Profile from "./pages/Profile.jsx";
import ChangePassword from "./pages/ChangePassword.jsx";
import Tutorial from "./pages/Tutorial.jsx";
import { PrivateRoute } from "./components/privateRoute";
import { AdminRoute } from "./components/AdminRoute";
import { PaidRoute } from "./components/PaidRoute";
import { GuestRoute } from "./components/GuestRoute";
import { PublicLayout } from "./layouts/PublicLayout.jsx";
import { AppLayout } from "./layouts/AppLayout.jsx";

function App() {
  return (
    <Router>
      <Toaster
        richColors
        position="bottom-right"
        closeButton
        duration={3000}
        toastOptions={{
          style: {
            width: "fit-content",
            maxWidth: "90vw",
            paddingRight: "6rem",
          },
          classNames: {
            toast: "w-fit",
          },
        }}
      />

      <Routes>
        {/* Área pública (marketing / auth) */}
        <Route element={<PublicLayout />}>
          <Route path="/" element={<GuestRoute><Home /></GuestRoute>} />
          <Route path="/login" element={<GuestRoute><Login /></GuestRoute>} />
          <Route path="/register" element={<GuestRoute><Register /></GuestRoute>} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
        </Route>

        {/* Área autenticada (app / admin) */}
        <Route element={<AppLayout />}>
          <Route path="/tutorial" element={<PrivateRoute><Tutorial /></PrivateRoute>} />
          <Route path="/dashboard" element={<PaidRoute><Dashboard /></PaidRoute>} />
          <Route path="/practice" element={<PaidRoute><Practice /></PaidRoute>} />
          <Route path="/configure-resume" element={<PaidRoute><ConfigureResume /></PaidRoute>} />
          <Route path="/generate-resume-ai" element={<PaidRoute><GenerateResumeWithAI /></PaidRoute>} />
          <Route path="/resume-preview" element={<PaidRoute><ResumePreview /></PaidRoute>} />
          <Route path="/download" element={<PaidRoute><DownloadPage /></PaidRoute>} />
          <Route path="/buy" element={<PrivateRoute><BuyPlans /></PrivateRoute>} />
          <Route path="/payment-success" element={<PrivateRoute><PaymentSuccess /></PrivateRoute>} />
          <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
          <Route path="/change-password" element={<PrivateRoute><ChangePassword /></PrivateRoute>} />
          <Route path="/admin" element={<AdminRoute><Admin /></AdminRoute>} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
